export default {
  textFont: "DM Sans",
  titleFont: "Josefin Sans",
  altText: "Poppins",
};
